/* --- actions ---*/
import axiosInstance from '../utils/axios';

const SET_UNREAD_NOTIFICATIONS = 'SET_UNREAD_NOTIFICATIONS';
const SET_UNREAD_REPORTS = 'SET_UNREAD_REPORTS';
const SET_PENDING_COMPLIANCE = 'SET_PENDING_COMPLIANCE';
const SET_UNREAD_NOTIFICATIONS_TIMEOUT_ID = 'SET_UNREAD_NOTIFICATIONS_TIMEOUT_ID';
const SET_UNREAD_REPORTS_TIMEOUT_ID = 'SET_UNREAD_REPORTS_TIMEOUT_ID';
const SET_PENDING_COMPLIANCE_TIMEOUT_ID = 'SET_PENDING_COMPLIANCE_TIMEOUT_ID';
const SET_NOTIFICATION_MODAL_OPEN_TIMESTAMP = 'SET_NOTIFICATION_MODAL_OPEN_TIMESTAMP';
const SET_REPORT_PAGE_VISIT_TIMESTAMP = 'SET_REPORT_PAGE_VISIT_TIMESTAMP';
const SET_COMPLIANCE_PAGE_VISIT_TIMESTAMP = 'SET_COMPLIANCE_PAGE_VISIT_TIMESTAMP';
const SET_REPORT_TABLE_RESET = 'SET_REPORT_TABLE_RESET';
const INC_TABLE_KEY = 'INC_TABLE_KEY';
const NOTIFICATIONS_EXECUTING = 'NOTIFICATIONS_EXECUTING';
const REPORTS_EXECUTING = 'REPORTS_EXECUTING';
const SHARES_EXECUTING = 'SHARES_EXECUTING';

const badges = {
  unreadNotificationsTimeoutID: {value: null},
  unreadReportsTimeoutID: {value: null},
  pendingComplianceTimeoutID: {value: null},
  unreadNotifications: {value: 0},
  unreadReports: {value: 0},
  pendingCompliance: {value: 0},
  notificationModalOpenTimestamp: {value: null},
  reportPageVisitTimestamp: {value: null},
  compliancePageVisitTimestamp: {value: null},
  reportTableReset: null,
  tableKey: 0,
  rerenderToggle: false,
};

export const _setUnreadNotificationsTimeoutID = timeout => ({type: SET_UNREAD_NOTIFICATIONS_TIMEOUT_ID, timeoutID: timeout});
export const _setUnreadReportsTimeoutID = timeout => ({type: SET_UNREAD_REPORTS_TIMEOUT_ID, timeoutID: timeout});
export const _setPendingComplianceTimeoutID = timeout => ({type: SET_PENDING_COMPLIANCE_TIMEOUT_ID, timeoutID: timeout});
export const _setReportTableReset = func => ({type: SET_REPORT_TABLE_RESET, tableReset: func});
export const _incTableKey = () => ({type: INC_TABLE_KEY});

export const _setNotificationModalOpenTimestamp = timestamp => ({
  type: SET_NOTIFICATION_MODAL_OPEN_TIMESTAMP,
  timestamp,
  unreadNotifications: 0,
});

export const _setReportPageVisitTimestamp = timestamp => ({
  type: SET_REPORT_PAGE_VISIT_TIMESTAMP,
  timestamp,
  unreadReports: 0,
});

export const _setCompliancePageVisitTimestamp = timestamp => ({
  type: SET_COMPLIANCE_PAGE_VISIT_TIMESTAMP,
  timestamp,
  pendingCompliance: 0,
});

export const _getUnreadNotifications = (unreadNotificationsTimeoutID, unreadNotifications, notificationModalOpenTimestamp) => (
  (dispatch, getState) => {
    if (!getState().badges?.notificationsExecuting) {
      dispatch({type: NOTIFICATIONS_EXECUTING, value: true});

      clearTimeout(unreadNotificationsTimeoutID.value);

      if (unreadNotifications.value || !localStorage.getItem('token')) {
        dispatch({type: NOTIFICATIONS_EXECUTING, value: false});
        return;
      }

      return axiosInstance.get('/user/notifications', {
        params: {
          ts: {$gte: notificationModalOpenTimestamp.value || 0},
          isRead: 0,
          limit: 1,
        },
      })
        .then(res => {
          let tmID = setTimeout(() => dispatch(_getUnreadNotifications(
            unreadNotificationsTimeoutID, unreadNotifications, notificationModalOpenTimestamp
          )), 120000);

          dispatch({type: SET_UNREAD_NOTIFICATIONS, unreadNotifications: res.data && res.data.length});
          dispatch({type: SET_UNREAD_NOTIFICATIONS_TIMEOUT_ID, timeoutID: tmID});
          dispatch({type: NOTIFICATIONS_EXECUTING, value: false});
        });
    }
  }
);

export const _getUnreadReports = (unreadReportsTimeoutID, unreadReports, reportPageVisitTimestamp, interval) => (
  (dispatch, getState) => {
    if (!getState().badges?.reportsExecuting) {
      dispatch({type: REPORTS_EXECUTING, value: true});
      clearTimeout(unreadReportsTimeoutID.value);

      if (unreadReports.value || !localStorage.getItem('token')) {
        dispatch({type: REPORTS_EXECUTING, value: false});
        return;
      }

      const encodedUrl = encodeURI('{"gte": "' + reportPageVisitTimestamp.value + '"}');
      const minTime = reportPageVisitTimestamp.value ? '&createdAt=' + encodedUrl : '';

      return axiosInstance.get('/documents/library?cat=Report&isRead=0&isShared=0&limit=1' + minTime)
        .then(res => {
          let tmID = null;

          if (res.data && !res.data.length) {
            tmID = setTimeout(() => dispatch(_getUnreadReports(
              unreadReportsTimeoutID, unreadReports, reportPageVisitTimestamp, interval
            )), interval);
          }

          dispatch({type: SET_UNREAD_REPORTS, unreadReports: res.data && res.data.length});
          dispatch({type: SET_UNREAD_REPORTS_TIMEOUT_ID, timeoutID: tmID});
          dispatch({type: REPORTS_EXECUTING, value: false});
        });
    }
  }
);

export const _getPendingCompliance = (pendingComplianceTimeoutID, pendingCompliance, compliancePageVisitTimestamp) => (
  (dispatch, getState) => {
    if (!getState().badges?.sharesExecuting) {
      dispatch({type: SHARES_EXECUTING, value: true});
      clearTimeout(pendingComplianceTimeoutID.value);

      if (pendingCompliance.value || !localStorage.getItem('token')) {
        dispatch({type: SHARES_EXECUTING, value: false});
        return;
      }

      const encodedUrl = encodeURI('{"gte": "' + compliancePageVisitTimestamp.value + '"}');
      const minTime = compliancePageVisitTimestamp.value ? '&createdAt=' + encodedUrl : '';

      return axiosInstance.get('/documents/shares?state=PENDING&limit=1' + minTime)
        .then(pendingShares => (axiosInstance.get('/documents/library?isNull=approved&compliance=1&limit=1' + minTime)
          .then(res => {
            let tmID = null;

            if (res.data && !res.data.length && pendingShares.data && !pendingShares.data.length) {
              tmID = setTimeout(() => dispatch(_getPendingCompliance(
                pendingComplianceTimeoutID, pendingCompliance, compliancePageVisitTimestamp
              )), 300000);
            }

            dispatch({
              type: SET_PENDING_COMPLIANCE,
              pendingCompliance: (res.data && res.data.length) || (pendingShares.data && pendingShares.data.length),
            });

            dispatch({type: SET_PENDING_COMPLIANCE_TIMEOUT_ID, timeoutID: tmID});
            dispatch({type: SHARES_EXECUTING, value: false});
          })
        ));
    }
  }
);

/* --- reducer ---*/
export default function reducer(state = badges, action) {
  const newState = {...state};

  newState.rerenderToggle = !state.rerenderToggle;

  switch (action.type) {
    case SET_UNREAD_NOTIFICATIONS:
      newState.unreadNotifications.value = action.unreadNotifications;
      break;
    case SET_UNREAD_REPORTS:
      newState.unreadReports.value = action.unreadReports;
      break;
    case SET_PENDING_COMPLIANCE:
      newState.pendingCompliance.value = action.pendingCompliance;
      break;
    case SET_UNREAD_NOTIFICATIONS_TIMEOUT_ID:
      newState.unreadNotificationsTimeoutID.value = action.timeoutID;
      break;
    case SET_UNREAD_REPORTS_TIMEOUT_ID:
      newState.unreadReportsTimeoutID.value = action.timeoutID;
      break;
    case SET_PENDING_COMPLIANCE_TIMEOUT_ID:
      newState.pendingComplianceTimeoutID.value = action.timeoutID;
      break;
    case SET_NOTIFICATION_MODAL_OPEN_TIMESTAMP:
      newState.notificationModalOpenTimestamp.value = action.timestamp;
      newState.unreadNotifications.value = action.unreadNotifications;
      break;
    case SET_REPORT_PAGE_VISIT_TIMESTAMP:
      newState.reportPageVisitTimestamp.value = action.timestamp;
      newState.unreadReports.value = action.unreadReports;
      break;
    case SET_COMPLIANCE_PAGE_VISIT_TIMESTAMP:
      newState.compliancePageVisitTimestamp.value = action.timestamp;
      newState.pendingCompliance.value = action.pendingCompliance;
      break;
    case SET_REPORT_TABLE_RESET:
      newState.reportTableReset = action.tableReset;
      break;
    case INC_TABLE_KEY:
      newState.tableKey = state.tableKey + 1;
      break;
    case NOTIFICATIONS_EXECUTING:
      newState.notificationsExecuting = action.value;
      break;
    case REPORTS_EXECUTING:
      newState.reportsExecuting = action.value;
      break;
    case SHARES_EXECUTING:
      newState.sharesExecuting = action.value;
      break;
    default:
      return state;
  }

  return newState;
}
